"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const BackButton_1 = __importDefault(require("./BackButton"));
const react_router_dom_1 = require("react-router-dom");
const material_1 = require("@mui/material");
const SearchAndLanguage_1 = __importDefault(require("./SearchAndLanguage"));
const MainContainer = styled_components_1.default.div `
  z-index: 3;
  position: absolute;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 8vh;
  background-color: white;
  padding-inline: 5vw;
  border-bottom: 1.5px solid rgba(0, 0, 0, 0.3);

  ${props => props.renderAs === 'footer' &&
    (0, styled_components_1.css) `
      bottom: 0;
      top: auto;
      border-top: 1px solid rgba(0, 0, 0, 0.3);

      @media (orientation: landscape) {
        display: none;
      }
    `}

  ${props => props.renderAs === 'header' &&
    (0, styled_components_1.css) `
      @media (orientation: portrait) {
        .back-button,
        .buttons-container {
          display: none !important;
        }
      }
    `}
    
  .title {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    margin-inline: auto;
  }
`;
const SubPageControlsBar = ({ renderAs }) => {
    var _a;
    const location = (0, react_router_dom_1.useLocation)();
    const isHeader = renderAs === 'header';
    return (react_1.default.createElement(MainContainer, { as: renderAs, renderAs: renderAs },
        react_1.default.createElement(BackButton_1.default, null),
        isHeader && (react_1.default.createElement(material_1.Typography, { className: "title", variant: "h5" }, ((_a = location === null || location === void 0 ? void 0 : location.state) === null || _a === void 0 ? void 0 : _a.tileTitle) || '')),
        react_1.default.createElement(SearchAndLanguage_1.default, { key: renderAs })));
};
exports.default = SubPageControlsBar;
